module.exports = __webpack_public_path__ + "media/components/breakheader/static/get_alerts--temp-9796be1fd87f3f9c289d8b14fb30fec9.gif";